/* eslint-disable @typescript-eslint/brace-style */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/member-ordering */


export class ApiLinks {
    public static readonly api: string = '/api-cutting/';

    /* AUTH */
    private static readonly _login: string = 'client/login';
    private static readonly _logout: string = 'client/logout';
    private static readonly _updateAccessToken: string = 'client/update-access-token';

    static get login(): string { return this.api + this._login; }
    static get logout(): string { return this.api + this._logout; }
    static get updateAccessToken(): string { return this.api + this._updateAccessToken; }

    /* ORDER */
    private static readonly _order: string = 'order';
    private static readonly _defaultOrderName: string = 'default-order-name';
    private static readonly _cuttingMaps: string = 'cutting-maps';
    private static readonly _offcuts: string = 'offcuts';
    private static readonly _estimate: string = 'estimate';
    private static readonly _cuttingHistory: string = 'tasks';
    private static readonly _setOrderStatus: string = 'set-order-status';
    private static readonly _orderToggleArchive: string = 'toggle-archive';
    private static readonly _panelSchema: string = 'get-panel-schema';
    private static readonly _cuttedMaterial: string = 'cutted-material';
    private static readonly _matBaseSlots: string = 'mat-base-grooves/names';
    private static readonly _vat: string = 'vat';
    private static readonly _createOrderCopy: string = 'create-copy';
    private static readonly _pointsOfIssue: string = 'point-of-issue';
    private static readonly _cuttingSettingFilesSyncDate: string = 'files-sync-date';
    private static readonly _deleteMultiple: string = 'delete-multiple';

    static get cuttingSettingFilesSyncDate(): string      { return this.api + this._order + '/' + this._cuttingSettingFilesSyncDate; }
    static get order(): string { return this.api + this._order; }
    static get pointsOfIssue(): string { return this.api + this._pointsOfIssue; }
    static get defaultOrderName(): string { return this.api + this._order + '/' + this._defaultOrderName; }
    static cuttingMaps(orderId: number): string { return this.api + this._order + '/' + orderId + '/' + this._cuttingMaps; }
    static offcuts(orderId: number): string { return this.api + this._order + '/' + orderId + '/' + this._offcuts; }
    static estimate(orderId: number): string { return this.api + this._order + '/' + orderId + '/' + this._estimate; }
    static cuttingHistory(orderId: number): string { return this.api + this._order + '/' + orderId + '/' + this._cuttingHistory; }
    static setOrderStatus(orderId: number): string { return this.api + this._order + '/' + orderId + '/' + this._setOrderStatus; }
    static orderToggleArchived(): string { return this.api + this._order + '/' + this._orderToggleArchive; }
    static panelSchema(orderId: number): string { return `${this.api + this._order}/${orderId}/${this._panelSchema}`; }
    static cuttedMaterial(orderId: number): string { return `${this.api + this._order}/${orderId}/${this._cuttedMaterial}`; }
    static get matBaseSlots(): string { return `${this.api + this._grooves}/names`; }
    static get vat(): string { return `${this.api + this._order}/${this._vat}`; }
    static createOrderCopy(orderId: number): string { return `${this.api + this._order}/${orderId}/${this._createOrderCopy}`; }
    static deleteMultipleFurnitures(orderId: number) : string { return `${this.api + this._cuttingOrderFurniture}/${orderId}/${this._deleteMultiple}`; }

    /* MATERIAL */
    private static readonly _material: string = 'material';
    private static readonly _butt: string = 'butt';
    private static readonly _buttsThickneses: string = 'butts-thickneses';
    private static readonly _orderMaterial: string = 'order';
    private static readonly _matchedButts: string = 'matched-butts';
    private static readonly _useMarSizeFromMatBase: string = 'use-mat-size-from-base';
    private static readonly _hasMatBase: string = 'has-mat-base';
    private static readonly _grooves: string = 'grooves';
    private static readonly _customGrooveOptions: string = 'custom-groove-options';
    private static readonly _customGrooveSchemas: string = 'schema';
    private static readonly _csv2panels: string = 'panels/parse-csv';
    private static readonly _panels2csv: string = 'panels/export-to-csv';
    private static readonly _findInMatbase: string = 'find-in-matbase';
    private static readonly _findButtInMatbase: string = 'find-butt-in-matbase';
        private static readonly _cuttingOrderFurniture: string = 'furniture';
    private static readonly _getCuttingOrderFurniture: string = 'furniture/order';
    private static readonly _materialTexture: string = 'texture';
    private static readonly _facades: string = 'facades';
    private static readonly _orderFacades: string = this._facades + '/order';
    private static readonly _orderFacadeMaterial: string = 'materials';

    static get material(): string { return this.api + this._material; }
    static get butt(): string { return this.api + this._material + '/' + this._butt; }
    static get buttsThickneses(): string { return this.api + this._material + '/' + this._buttsThickneses; }
    static get orderMaterial(): string { return this.api + this._material + '/' + this._orderMaterial; }
    static orderFacadeMaterial(orderId: number): string { return this.api + this._orderFacades + '/' + orderId + '/' + this._orderFacadeMaterial; }
    static get orderFacade(): string { return this.api + this._facades; }
    static get matchedButts(): string { return this.api + this._material + '/' + this._matchedButts; }
    static get useMarSizeFromMatBase(): string { return this.api + this._material + '/' + this._useMarSizeFromMatBase; }
    static get hasMatBase(): string { return this.api + this._material + '/' + this._hasMatBase; }
    static get grooves(): string { return `${this.api}${this._grooves}`; }
    static get customGrooveOptions(): string { return `${this.api}${this._grooves}/${this._customGrooveOptions}`; }
    static get customGrooveSchemas(): string { return `${this.api}${this._grooves}/${this._customGrooveSchemas}`; }
    static get csv2panels(): string { return `${this.api + this._material}/${this._csv2panels}`; }
    static panels2csv(materialId: number): string { return `${this.api + this._material}/${materialId.toString()}/${this._panels2csv}`; }
    static get findInMatbase(): string { return `${this.api + this._material}/${this._findInMatbase}`; }
    static get findButtInMatbase(): string { return `${this.api + this._material}/${this._findButtInMatbase}`; }
    static cadModelMaterials(modelId: number): string { return `${this.api + this._cadModels}${modelId}/details`; }
    static get cuttingOrderFurniture(): string { return `${this.api + this._cuttingOrderFurniture}`; }
    static getCuttingOrderFurniture(orderId: number): string { return `${this.api + this._getCuttingOrderFurniture}/${orderId}`; }
    static get materialTexture(): string { return this.api + this._material + '/' + this._materialTexture; }

    /* CLIENT */
    private static readonly _passwordRecovery: string = 'client/recovery-password';
    private static readonly _checkPasswordRecoveryKey: string = 'client/recovery-password-check';
    private static readonly _clientExtended: string = 'client/extended';
    private static readonly _setNewPassword: string = 'client/set-new-password';
    private static readonly _changePassword: string = 'client/change-password';
    // private static readonly _changePasswordByKey: string = 'client/change-password-by-key';
    private static readonly _clientOptions: string = 'client/client-options';
    private static readonly _client: string = 'client';
    private static readonly _activateClient: string = 'client/activate-client-by-key';
    private static readonly _usePhoneNumber: string = 'use-phone-number';
    private static readonly _adminCountryCode: string = 'admin-country-code';
    private static readonly _clientRegisteredOptions: string = 'registered-options';
    private static readonly _clientConfirmMode: string = 'get-confirmation-type';
    private static readonly _cuttingSettings: string = 'cutting-settings';
    private static readonly _presetSettings: string = 'preset-settings';
    private static readonly _activateClientBySmsCode: string = 'activate-client-by-sms-code';
    private static readonly _resendActivateSmsCode: string = 'resend-activate-sms-code';
    private static readonly _setNewEmail: string = 'set-new-email';
    private static readonly _sendChangeEmailMess: string = 'change-email';
    private static readonly _availableTariffOptions: string = 'available-tariff-options';
    private static readonly _managers: string = 'managers';
    private static readonly _userInfo: string = 'get-user-info';

    static get sendChangeEmailMess(): string { return this.api + this._client + '/' + this._sendChangeEmailMess; }
    static get setNewEmail(): string { return this.api + this._client + '/' + this._setNewEmail; }
    static get managers(): string { return this.api + this._client + '/' + this._managers; }
    static get passwordRecovery(): string { return this.api + this._passwordRecovery; }
    static get checkPasswordRecoveryKey(): string { return this.api + this._checkPasswordRecoveryKey; }
    static get clientExtended(): string { return this.api + this._clientExtended; }
    static get setNewPassword(): string { return this.api + this._setNewPassword; }
    static get changePassword(): string { return this.api + this._changePassword; }
    static get clientOptions(): string { return this.api + this._clientOptions; }
    static get adminCountryCode(): string { return this.api + this._client + '/' + this._adminCountryCode; }
    static get client(): string { return this.api + this._client; }
    static get activateClient(): string { return this.api + this._activateClient; }
    static get usePhoneNumber(): string { return this.api + this._client + '/' + this._usePhoneNumber; }
    static get clientRegisteredOptions(): string { return this.api + this._client + '/' + this._clientRegisteredOptions; }
    static get clientConfirmMode(): string { return this.api + this._client + '/' + this._clientConfirmMode; }
    static get activateClientBySmsCode(): string { return `${this.api + this._client}/${this._activateClientBySmsCode}`; }
    static get resendActivateSmsCode(): string { return `${this.api + this._client}/${this._resendActivateSmsCode}`; }
    static get cuttingSettings(): string { return `${this.api + this._client}/${this._cuttingSettings}`; }
    static get presetSettings(): string { return `${this.api + this._client}/${this._presetSettings}`; }
    static get availableTariffOptions(): string { return `${this.api + this._client}/${this._availableTariffOptions}`; }
    static get userInfo(): string { return `${this.api + this._client}/${this._userInfo}`; }
    static get bannerSetting(): string {return `${this.api + this._client}/banner`;}

    /* QUESTION */
    private static readonly _orderQuestion: string = 'order-question';
    private static readonly _orderQuestionMsg: string = 'message';
    private static readonly _orderQuestionMsgFile: string = 'files';
    private static readonly _orderQuestionChatHub: string = '/hubs/cutting-order-question-chat';
    private static readonly _restoreQuestion: string = 'restore';
    private static readonly _closeQuestion: string = 'close';
    private static readonly _cuttingOrderMessagesMarkAsRead: string = 'mark-as-read';
    private static readonly _cuttingOrderUnreadedMessagesCount: string = 'unreaded-messages-count';

    static newOrderQuestion(): string { return `${this.api + this._orderQuestion}`; }
    static orderQuestion(questionId: number): string { return `${this.api + this._orderQuestion}/${questionId}`; }
    static orderQuestionMessageFiles(questionId: number, messageId: number): string
        { return `${this.api + this._orderQuestion}/${questionId}/${this._orderQuestionMsg}/${messageId}/${this._orderQuestionMsgFile}`; }
    static orderQuestionMessage(questionId: number): string { return `${this.api + this._orderQuestion}/${questionId}/${this._orderQuestionMsg}`; }
    static orderUnreadedMessagesCount(questionId: number): string { return `${this.api + this._orderQuestion}/${questionId}/${this._cuttingOrderUnreadedMessagesCount}`; }
    static get orderQuestionChatHub(): string { return this._orderQuestionChatHub; }
    static restoreQuestion(questionId: number): string { return this.api + this._orderQuestion + '/' + questionId + '/' + this._restoreQuestion; }
    static closeQuestion(questionId: number): string { return this.api + this._orderQuestion + '/' + questionId + '/' + this._closeQuestion; }
    static cuttingOrderMessagesMarkAsRead(questionId: number): string { return this.api + this._orderQuestion + '/' + questionId + '/' + this._cuttingOrderMessagesMarkAsRead; }

    // CLIENT MATERIAL
    private static readonly _clientMaterials: string = 'client-materials';

    static get clientMaterials(): string { return `${this.api + this._clientMaterials}`; }

    // DOCUMENTS
    private static readonly _cuttingStaticDocuments: string = 'static-documents';
    private static readonly _cuttingDocuments: string = 'documents';
    private static readonly _cuttingOrderSysDocuments: string = 'system';
    private static readonly _cuttingOrderCustomDocuments: string = 'custom';
    private static readonly _toPdf: string = 'to-pdf';
    private static readonly _html2Pdf: string = 'html';

    static get docBuilderHost(): string { return '/'; }
    static get html2Pdf(): string { return `${this.api + this._toPdf}/${this._html2Pdf}`; }
    static get cuttingOrderSysDocuments(): string { return this.api + this._cuttingDocuments + '/' + this._cuttingOrderSysDocuments + '/cutting-order'; }
    static get cuttingOrderCustomDocuments(): string { return this.api + this._cuttingDocuments + '/' + this._cuttingOrderCustomDocuments + '/cutting-order'; }
    static get cuttingStaticDocuments(): string { return `${this.api + this._cuttingStaticDocuments}`; }

    /* FILE */
    private static readonly _cadModels: string = 'order-cadmodels/';

    static orderModel(orderId: number): string { return this.api + this._cadModels + 'order/' + orderId.toString(); }
    static cadModel(modelId: number): string { return this.api + this._cadModels + modelId.toString(); }
    static cadModelLinkMaterial(modelId: number): string { return this.api + this._cadModels + modelId.toString() + '/set-link-material'; }
    static get deleteCadModels(): string { return this.api + this._cadModels + this._deleteMultiple; }

    /* PAYMENTS */
    private static readonly _avaliablePaySystems: string = 'payments/avaliable-pay-systems';
    private static readonly _psbPay: string = 'payments/PSB';
    private static readonly _payPalPay: string = 'payments/paypal';
    private static readonly _wooppayPay: string = 'payments/wooppay';

    static get avaliablePaySystems(): string { return this.api + this._avaliablePaySystems; }
    static get psbPay(): string { return this.api + this._psbPay; }
    static get payPalPay(): string { return this.api + this._payPalPay; }
    static get wooppayPay(): string { return this.api + this._wooppayPay; }

    /* ELASTIC MODELS */
    private static readonly _elasticModels: string = 'elastic-model';
    private static readonly _elasticModelGroups: string = 'groups';
    private static readonly _elasticModelGroupTexture: string = 'texture';
    private static readonly _elasticModelPriceList: string = 'price-list';
    private static readonly _elasticModelProducts: string = 'products';
    private static readonly _elasticModelTexture: string = 'texture';
    private static readonly _elasticModelElements: string = 'elements';
    private static readonly _elasticModelElementMaterials: string = 'materials';
    private static readonly _elasticProduct: string = 'product/order';
    private static readonly _cadModelAvailableHoleDiams: string = 'fasteners/avaliable-diameters';

    static get elasticModels(): string { return `${this.api + this._elasticModels}`; }
    static elasticProduct(orderId: number): string { return `${this.api + this._elasticModels}/${this._elasticProduct}/${orderId}`; }
    static get elasticModelPriceList(): string { return `${this.api + this._elasticModels}/${this._elasticModelPriceList}`; }
    static elasticModelGroupTexture(picturePath: string, priceId: number, userId: number): string
        { return `${this.api + this._elasticModels}/${this._elasticModelPriceList}/${priceId}/${this._elasticModelGroups}-texture/${userId}/${picturePath}`; }
    static get cadModelAvailableHoleDiams(): string { return this.api + this._cadModelAvailableHoleDiams; }
    static elasticModelElementMaterials(productId: number, elementId: number): string
        { return `${this.api + this._elasticModels}/${this._elasticModelProducts}/${productId}/${this._elasticModelElements}/${elementId}/${this._elasticModelElementMaterials}`; }
    static get elasticModelTexture(): string { return this.api + this._elasticModels + '/' + this._elasticModelTexture; }
    static elasticModelGroups(priceId: number): string { return `${this.api + this._elasticModels}/${this._elasticModelPriceList}/${priceId}/${this._elasticModelGroups}`; }
    static elasticModelProducts(groupId: number, priceId: number): string
        { return `${this.api + this._elasticModels}/${this._elasticModelPriceList}/${priceId}/${this._elasticModelGroups}/${groupId}/${this._elasticModelProducts}`; }
    static elasticModelProductInfo(productId: number): string { return `${this.api + this._elasticModels}/${this._elasticModelProducts}/${productId}/info`; }
    static elasticProoductGlbModel(uid: string): string { return `${this.api + this._elasticModels}/${this._elasticModelProducts}/${uid}/viewer-model`; }

    /* NOTIFICATIONS */
    static _notfications = 'notifications';

    static get notfications(): string { return this.api + this._notfications; }

    /* HUBS */
    private static readonly _cuttingWorkerHub: string = '/hubs/cutting';
    private static readonly _cuttingNotificationHub: string = '/hubs/notification';

    static get cuttingWorkerHub(): string { return this._cuttingWorkerHub; }
    static get cuttingNotificationHub(): string { return this._cuttingNotificationHub; }

    /* OTHER */
    private static readonly _googlePlaceAutocomplete: string = 'place-autocomplete';
    private static readonly _dadata: string = 'dadata';

    static get googlePlaceAutocomplete(): string { return this.api + this._googlePlaceAutocomplete; }
    static get dadata(): string { return this.api + this._dadata; }
}
